import React from 'react';

import LoadCompanyList from 'bundle-loader?lazy&name=company-list!./components/routes/company-list/company-list-container';
import LoadCompany from 'bundle-loader?lazy&name=company!./components/routes/company/company-container';

const Bundle = ( Component ) => (
    ( props ) => (
        <Component { ...props } />
    )
);

export const routes = [ {
    title: 'Company Setup',
    pattern: '/',
    load: LoadCompanyList
},
{
    title: 'Company Setup',
    pattern: '/company-list',
    load: LoadCompanyList
},
{
    title: 'Company',
    pattern: '/company/:id?',
    load: LoadCompany
} ];

export const getMiddleware = () => {
    return [
        // Load Bundles
        ( action, nextRoute, prevRoute ) => {
            const { match } = nextRoute;

            if (
                match &&
                !match.render &&
                typeof match.load === 'function'
            ) {

                match.load( ( asyncModule ) => {
                    match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
                    action.ok();
                } );
            } else {
                action.ok();
            }
        }
    ];
};
